import { render } from "./LocationSection.vue?vue&type=template&id=784bd9b9"
import script from "./LocationSection.vue?vue&type=script&lang=js"
export * from "./LocationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__